<template>
  <BaseTemplate
    :currentUser="currentUser"
    :class="['anime_base', { 'black-background': !isShowVideo }]"
    :isShowBaseContents="false">
    <div class="gacha-animation">
      <div
        v-if="isShowVideo"
        class="video-container"
      >
        <video
          class="video"
          ref="video"
          :src="currentVideoSrc"
          preload="auto"
          playsinline
          @ended="handleVideoEnd"
        />
      </div>
      <div
        v-else
        class="open-card-container"
      >
      <OpenCard
        ref="openCard"
        :cards="formattedCards"
        @handleOpenCardEnd="goToGetCardList"
      />
        <!-- <SquareButton
          class="square-button"
          :text="t('次へ')"
          @handleSquareBtnClick="handleNextBtnClick"
        /> -->
      </div>
      <!-- <iframe :src="sound.rare" allow="autoplay" style="display:none" id="iframeAudio">
      </iframe> -->
      <!-- <audio ref="audioObj" :src="sound.rare"></audio> -->
    </div>
    <!-- <CommonOverlay
      ref="commonOverlay"
      v-show="isShowOverlay"
      class="overlay"
      @handleOverlayClick="startAnimation"
    >
      <div v-if="!isMobile" class="pc button-group">
        <img class="pc-left" src="/img/gacha/message-pc-1.png"/>
        <img class="pc-center" src="/img/gacha/message-pc-2.png"/>
        <img class="pc-right" src="/img/gacha/message-pc-3.png"/>
      </div>
      <div v-else class="sp button-group">
        <img class="sp-left" src="/img/gacha/message-sp-1.png"/>
        <img class="sp-center" src="/img/gacha/message-sp-2.png"/>
        <img class="sp-right" src="/img/gacha/message-sp-3.png"/>
      </div>
    </CommonOverlay> -->
      <SkipButton
        ref="skipAll"
        v-show="isShowVideo"
        class="skip-button all"
        text="skip"
        @handleSkipClick="skipAllAnimation"
        v-click-outside="skipVideo"
      />
    <SkipButton
      v-show="!isShowVideo && isExistNextCard"
      class="skip-button card one"
      text="skip"
      @handleSkipClick="showNextCard"
    />
  </BaseTemplate>
</template>

<script>
import { transRarity } from '@/common/config/js/const';
import { mapGetters } from 'vuex';

import ClickOutside from 'vue-click-outside';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
// import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
// import SquareButton from '@/components/atoms/SquareButton.vue';
import SkipButton from '@/components/atoms/SkipButton.vue';
import OpenCard from '@/components/molecules/OpenCard02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'GachaAnimation',
  mixins: [t],

  beforeRouteLeave(to, from, next) {
    if (to.name === 'ConfirmBuyProduct') {
      next(false);
    } else {
      next();
    }
  },

  components: {
    BaseTemplate,
    // CommonOverlay,
    // SquareButton,
    SkipButton,
    OpenCard,
  },

  directives: {
    ClickOutside,
  },

  data: () => ({
    isIos: /iP(hone|(o|a)d)/.test(navigator.userAgent),
    // isShowOverlay: true,
    isMobile: window.innerWidth <= 768,
    isCardOpen: false,
    isSkipCardOpen: false,
    isShowVideo: true,
    isEnabledVideoSkip: false,
    videoObj: null,
    cardIndexCount: 0,
    videoSrcList: {
      movie01: '/video/omikuzi_white.mp4?v=1',
      movie02: '/video/omikuzi_blue.mp4?v=1',
      movie03: '/video/omikuzi_yellow.mp4?v=1',
      movie04: '/video/omikuzi_green.mp4?v=1',
      movie05: '/video/omikuzi_red.mp4?v=1',
      movie06: '/video/omikuzi_rainbow.mp4?v=1',
      movie07: '/video/omikuzi_premium.mp4?v=1',
      normal: '/video/omikuzi_white.mp4?v=1',
    },
    isEnabledSkipCardOpen: false,
    // isEnabledSound: false,
    // audioObj: null,
    // sound: {
    //   rare: '/sound/rare.mp3',
    // },
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      buyPackResult: 'pack/buyPackResult',
    }),
    isExistNextCard() {
      if (this.buyPackResult) {
        return this.cardIndexCount < this.buyPackResult.cards.length - 1;
      }
      return 0;
    },
    currentGetCard() {
      if (this.buyPackResult) {
        const targetCard = this.buyPackResult.cards[this.cardIndexCount];
        if (targetCard) {
          const rarity = transRarity[targetCard.rarity];
          return { ...targetCard, rarity };
        }
        return { ...targetCard, rarity: 'normal' };
      }
      return {};
    },
    formattedCards() {
      return this.buyPackResult?.cards?.map((card) => ({
        frontImage: card.image,
        backImage: card.back_image || card.image,
        rarity: Number(card.rarity) >= 4 ? 'rare' : 'normal',
      })) || [];
    },
    currentVideoSrc() {
      if (this.buyPackResult) {
        if (this.buyPackResult.cards.length === 0) {
          return this.videoSrcList.normal;
        }
        // const { rarity } = this.buyPackResult.cards[this.cardIndexCount];
        const rarity = this.buyPackResult.gacha_amimation;
        let srcPath = null;
        if (rarity === '1') {
          srcPath = this.videoSrcList.movie01;
          if (this.buyPackResult.movie_style === '1') {
            srcPath = './video/omikuzi_white.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '2') {
            srcPath = './video/kingyo_white.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '3') {
            srcPath = './video/syateki_white.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '4') {
            srcPath = './video/metal_white.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '5') {
            srcPath = './video/warp_white.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '6') {
            srcPath = './video/kago_white.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '7') {
            srcPath = './video/digital_white.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '8') {
            srcPath = './video/goods_white.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '9') {
            srcPath = './video/chiru_white.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '10') {
            srcPath = './video/gate_white.mp4?v=1';
          } else {
            srcPath = './video/omikuzi_white.mp4?v=1';
          }
        } else if (rarity === '2') {
          srcPath = this.videoSrcList.movie02;
          if (this.buyPackResult.movie_style === '1') {
            srcPath = './video/omikuzi_blue.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '2') {
            srcPath = './video/kingyo_blue.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '3') {
            srcPath = './video/syateki_blue.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '4') {
            srcPath = './video/metal_blue.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '5') {
            srcPath = './video/warp_blue.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '6') {
            srcPath = './video/kago_blue.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '7') {
            srcPath = './video/digital_blue.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '8') {
            srcPath = './video/goods_blue.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '9') {
            srcPath = './video/chiru_blue.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '10') {
            srcPath = './video/gate_blue.mp4?v=1';
          } else {
            srcPath = './video/omikuzi_blue.mp4?v=1';
          }
        } else if (rarity === '3') {
          srcPath = this.videoSrcList.movie03;
          if (this.buyPackResult.movie_style === '1') {
            srcPath = './video/omikuzi_yellow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '2') {
            srcPath = './video/kingyo_yellow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '3') {
            srcPath = './video/syateki_yellow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '4') {
            srcPath = './video/metal_yellow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '5') {
            srcPath = './video/warp_yellow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '6') {
            srcPath = './video/kago_yellow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '7') {
            srcPath = './video/digital_yellow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '8') {
            srcPath = './video/goods_yellow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '9') {
            srcPath = './video/chiru_yellow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '10') {
            srcPath = './video/gate_yellow.mp4?v=1';
          } else {
            srcPath = './video/omikuzi_yellow.mp4?v=1';
          }
        } else if (rarity === '4') {
          srcPath = this.videoSrcList.movie04;
          if (this.buyPackResult.movie_style === '1') {
            srcPath = './video/omikuzi_green.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '2') {
            srcPath = './video/kingyo_green.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '3') {
            srcPath = './video/syateki_green.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '4') {
            srcPath = './video/metal_green.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '5') {
            srcPath = './video/warp_green.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '6') {
            srcPath = './video/kago_green.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '7') {
            srcPath = './video/digital_green.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '8') {
            srcPath = './video/goods_green.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '9') {
            srcPath = './video/chiru_green.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '10') {
            srcPath = './video/gate_green.mp4?v=1';
          } else {
            srcPath = './video/omikuzi_green.mp4?v=1';
          }
        } else if (rarity === '5') {
          srcPath = this.videoSrcList.movie05;
          if (this.buyPackResult.movie_style === '1') {
            srcPath = './video/omikuzi_red.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '2') {
            srcPath = './video/kingyo_red.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '3') {
            srcPath = './video/syateki_red.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '4') {
            srcPath = './video/metal_red.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '5') {
            srcPath = './video/warp_red.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '6') {
            srcPath = './video/kago_red.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '7') {
            srcPath = './video/digital_red.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '8') {
            srcPath = './video/goods_red.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '9') {
            srcPath = './video/chiru_red.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '10') {
            srcPath = './video/gate_red.mp4?v=1';
          } else {
            srcPath = './video/omikuzi_red.mp4?v=1';
          }
        } else if (rarity === '6') {
          srcPath = this.videoSrcList.movie06;
          if (this.buyPackResult.movie_style === '1') {
            srcPath = './video/omikuzi_rainbow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '2') {
            srcPath = './video/kingyo_rainbow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '3') {
            srcPath = './video/syateki_rainbow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '4') {
            srcPath = './video/metal_rainbow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '5') {
            srcPath = './video/warp_rainbow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '6') {
            srcPath = './video/kago_rainbow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '7') {
            srcPath = './video/digital_rainbow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '8') {
            srcPath = './video/goods_rainbow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '9') {
            srcPath = './video/chiru_rainbow.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '10') {
            srcPath = './video/gate_rainbow.mp4?v=1';
          } else {
            srcPath = './video/omikuzi_rainbow.mp4?v=1';
          }
        } else if (rarity === '7') {
          srcPath = this.videoSrcList.movie07;
          if (this.buyPackResult.movie_style === '1') {
            srcPath = './video/omikuzi_premium.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '2') {
            srcPath = './video/kingyo_premium.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '3') {
            srcPath = './video/syateki_premium.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '4') {
            srcPath = './video/metal_premium.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '5') {
            srcPath = './video/warp_premium.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '6') {
            srcPath = './video/kago_premium.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '7') {
            srcPath = './video/digital_premium.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '8') {
            srcPath = './video/goods_premium.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '9') {
            srcPath = './video/chiru_premium.mp4?v=1';
          } else if (this.buyPackResult.movie_style === '10') {
            srcPath = './video/gate_premium.mp4?v=1';
          } else {
            srcPath = './video/omikuzi_premium.mp4?v=1';
          }
        }
        return srcPath;
      }
      return null;
    },
    isBuyCoin() {
      if (this.buyPackResult) {
        return this.buyPackResult.is_buy_coin;
      }
      return false;
    },
  },

  mounted() {
    this.popupItem = this.$refs.skipAll;
    window.addEventListener('resize', this.handleResize);
    this.startAnimation();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    startAnimation() {
      // this.isShowOverlay = false;
      this.videoObj = this.$refs.video;
      this.videoObj.muted = false;
      setTimeout(() => {
        this.videoObj.play();
      }, 300);
      this.isEnabledVideoSkip = true;
      // MEMO: 効果音の再生がうまくいかない。一旦コメントアウト
      // this.$refs.audioObj.muted = true;
      // this.$refs.audioObj.play();
    },
    handleVideoEnd() {
      this.goToGetCardList();
    },
    openCard() {
      // メモ: テスト環境でカードの回転が起こらなかったため、遅延処理
      setTimeout(() => {
        this.isCardOpen = true;
      }, 300);
    },
    handleNextBtnClick() {
      if (this.isExistNextCard) {
        this.nextAnimationReady();
        return;
      }
      this.goToGetCardList();
    },
    nextAnimationReady() {
      this.isShowVideo = true;
      this.isCardOpen = false;
      this.isShowOverlay = true;
      this.isSkipCardOpen = false;
      this.addCardIndexCount();
      // this.setIsEnabledSound(false);
      // this.resetSound();
    },
    openCardReady() {
      this.isEnabledVideoSkip = false;
      this.isEnabledSkipCardOpen = true;
      // this.setIsEnabledSound(true);
      this.isShowVideo = false;
    },
    addCardIndexCount() {
      this.cardIndexCount += 1;
    },
    skipVideo() {
      if (this.isEnabledVideoSkip) {
        this.isEnabledVideoSkip = false;
        this.goToGetCardList();
      }
    },
    skipOpenCard() {
      if (this.isEnabledSkipCardOpen) {
        this.isSkipCardOpen = true;
        // this.soundPlay();
        this.isEnabledSkipCardOpen = false;
      }
    },
    // soundPlay() {
    //   if (this.isEnabledSound) {
    //     this.$refs.audioObj.muted = false;
    //     const result = this.$refs.audioObj.play();
    //     this.setIsEnabledSound(false);
    //   }
    // },
    // resetSound() {
    //   this.$refs.audioObj.pause();
    //   this.$refs.audioObj.currentTime = 0;
    // },
    // setIsEnabledSound(boolean) {
    //   // 効果音再生を許可するレアリティ
    //   const enabledSoundRarityList = [transRarity[2], transRarity[3]];
    //   const isEnabled = enabledSoundRarityList.includes(this.currentGetCard.rarity);
    //   this.isEnabledSound = (isEnabled && boolean);
    // },
    disabledSkipOpenCard() {
      this.isEnabledSkipCardOpen = false;
    },
    showNextCard() {
      const openCardComponent = this.$refs.openCard;
      if (openCardComponent && typeof openCardComponent.skipCard === 'function') {
        openCardComponent.skipCard(); // ← これで OpenCard 内の skip 演出を終了
      }
      this.skipOpenCard();
      this.addCardIndexCount();
    },
    skipAllAnimation() {
      if (this.isBuyCoin) {
        this.$router.push('/thank-you');
      } else {
        this.$router.push('/get-card-list');
      }
    },
    goToGetCardList() {
      if (this.isBuyCoin) {
        this.$router.push('/thank-you');
      } else {
        this.$router.push('/get-card-list');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.anime_base {
  // background-color: $mainColor!important;
  background-color: #000000!important;
  &.black-background {
    background-color: #121212!important;
  }
}
.gacha-animation{
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 580px;
  min-height: 100%;
  margin: -20px auto 0 auto;
  transition: all 1s ease;
  @media screen and (max-width: $tabletWidth) {
    max-width: 100%;
    margin-top: 0;
    height: 100vh;
  }
  .video-container{
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    .video{
      //width: 100%;
      height: 100vh;
      @media screen and (max-width: $tabletWidth) {
        height: 100vh;
      }
    }
    .gacha-btn{
      position: absolute;
    }
  }
  .open-card-container{
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .square-button{
      width: 120px;
      height: 50px;
      margin: 60px auto 0px;
    }
  }
}
.overlay{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url('/img/gacha/back_pc.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  @media screen and  (max-width: $tabletWidth) {
    background-image: url('/img/gacha/back_sp.png');
  }
  .button-group {
    position: absolute;
    width: 100%;
    height: 100%;
    pointer-events: none;
    img {
      position: absolute;
      pointer-events: auto;
      cursor: pointer;
    }
    &.sp {
      .sp-left {
        top: 0;
        left: 0;
        height: 350px;
        width: auto;
        @media screen and (max-width: $mobileWidth) {
          height: 250px;
        }
      }
      .sp-center {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 370px;
        height: auto;
      }
      .sp-right {
        bottom: 0;
        right: 0;
        height: 350px;
        width: auto;
        @media screen and (max-width: $mobileWidth) {
          height: 250px;
        }
      }
    }
    &.pc {
      .pc-left {
        top: 0;
        left: 0;
        height: 100%;
        width: 450px;
      }
      .pc-center {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 1920px;
        height: auto;
      }
      .pc-right {
        top: 0;
        right: 0;
        height: 100%;
        width: 450px;
      }
    }
  }
}
.skip-button{
  position: absolute;
  top: 30px;
  right: 20px;
  cursor: pointer;
  &.animation.one{
    top: 0px;
  }
}
</style>
